import { store } from '@/store'
import dialog from '@/helpers/dialog'
import routes from '@/helpers/routes'
import { getRouter } from '@/helpers/nav'

async function check () {
  try {
    await store.dispatch('user/checkToken')

    return true
  } catch {
    dialog.message('Sitzung abgelaufen', 'Aus Sicherheitsgründen wurde Ihre Sitzung beendet. Bitte melden Sie sich erneut an.', 'agila:account')
    store.dispatch('user/logout')
    getRouter().push(routes.internal.login)

    return false
  }
}

export default {
  check
}